import React from "react";
import { Route, Switch } from "react-router-dom";
// import Inbox from "./inbox/index";
import ProductForm from "./creactEditeProduct";
import ProductUpdate from "./creactEditeProduct/update";
import ProductList from "./productList";
import "./creactEditeProduct/index.css";
const Production = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/add`} component={ProductForm} />
      <Route
        path={`${match.url}/:productId/update`}
        component={ProductUpdate}
      />
      <Route path={`${match.url}/:productStatus`} component={ProductList} />
      {/* <Route path={`${match.url}/:dealerType`} component={Inbox} /> */}
    </Switch>
  );
};

export default Production;
